import React from 'react';
import { PaymentHistoryItem } from '../../../interfaces/payment.interface';
import { convertTimestampToDateTime } from '../../../helper/helper';

interface PaymentHistoryTableProps {
  paymentHistory: PaymentHistoryItem[];
}

const PaymentHistoryTable: React.FC<PaymentHistoryTableProps> = ({ paymentHistory }) => {
  return (
    <div className="w-full overflow-auto">
      <table className="min-w-full border border-gray-300">
        <thead>
          <tr>
            <th className="py-2 text-left px-4 border-b">Amount Charged</th>
            <th className="py-2 text-left px-4 border-b">Coupon</th>
            <th className="py-2 text-left px-4 border-b">Discount Availed</th>
            <th className="py-2 text-left px-4 border-b">Payment Description</th>
            <th className="py-2 text-left px-4 border-b">Payment Time</th>
          </tr>
        </thead>
        <tbody>
          {paymentHistory.map((payment, index) => (
            <tr key={index} className={index % 2 === 0 ? 'bg-gray-100' : ''}>
              <td className="py-2 text-left px-4 border-b">
                ${' '}
                {payment?.couponDiscount
                  ? (payment?.amount - payment?.couponDiscount).toFixed(2)
                  : payment?.amount}
              </td>
              <td className="py-2 text-left px-4 border-b">{payment?.coupon || '-'}</td>
              <td className="py-2 text-left px-4 border-b">
                {payment?.couponDiscount ? `$ ${payment?.couponDiscount}` : '-'}
              </td>
              <td className="py-2 text-left px-4 border-b">{payment?.description}</td>
              <td className="py-2 text-left px-4 border-b">
                {convertTimestampToDateTime(payment?.timestamp)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentHistoryTable;
